module.exports = __webpack_public_path__ + "static/media/LogoNotLetter.7c2f5da4.png";